export const CUSTOMER_ROUTE = "/customer";
